import { observer } from "mobx-react-lite";
import React, { useEffect, useState ,useContext} from "react";
import CityCountrySelect from "./CityCountrySelect";
import { AutoSuggest } from 'react-autosuggestions';
import './style.css';
import { I18nContext } from "../../store/context/i18nContext";

const AddressField = ({
  className,
  value,
  style,
  onChange = () => { },
  label,
  outline
}) => {

  const [addressLines] = useState([])
  const {t} =useContext(I18nContext);

  useEffect(() => {

  }, [value?.city, value?.addressLine])

  return (
    <div className={className + " d-flex justify-content-center align-items-center "} style={{...style}}>
      {outline ??
        <div
          style={{ width: "120px", fontSize: 12, fontWeight: "500" }}
        >
          {label ?? t("Address")}
        </div>}
      <div style={{ margin: "10px 0px 5px 0px", height: "36px" }} className="input-group flex-1">
        <div className="input-group-prepend col-4" >
          <CityCountrySelect
            style={{ borderRadius: "15px 0px 0px 15px", fontSize: '16px' }}
            value={value}
            onChange={(v) => {
              onChange({
                ...value,
                city: v?.value,
                country: v?.country,
                state: v?.state,
                lat: v?.lat,
                lng: v?.lng,
                addressLine: v?.addressLine
              })
            }}
          />
        </div>
        <div className="autosuggestWrapper">
          <AutoSuggest
            name="addressLine"
            options={addressLines}
            handleChange={v => {
              onChange({ ...value, addressLine: v })
            }}
            value={value?.addressLine}
          />
        </div>
      </div>
    </div>
  );
}

export default observer(AddressField);


